<script setup>
	import { ref, computed, defineEmits, defineProps, defineExpose } from 'vue';
	import { useStore } from 'vuex';
	import { formConfig } from '@/js/formConfig.js';
	import { getReadableDate } from "../js/tools.js";
	
	// eslint-disable-next-line no-unused-vars
	import DevLive from "@/components/DevLive.vue";

	/*
	import config from "../config";
	import { customLog } from "../js/customlog.js";
	const log = (str, type) => { if ( config.isAdminNavAllowed ){ customLog(str, type); }}; 
	*/
	const fc = formConfig;
	const emit = defineEmits(['goto', 'trigger']);
	const props = defineProps({
		'lead': {
			type: Object,
			required: true,
		}
	});
	const retracted = ref(false);
	const shortDate = dateString => {
		return getReadableDate(new Date(dateString)).slice(0, 10);
	};
	const offersStatusUnworkable = computed(() => {
		return ['W', 'O', 'H', 'P', 'C', 'A', 'R'].includes(props.lead.offerstatus);
	});

	const store = useStore(); // composition api equivalent of "this.$store"
	// eslint-disable-next-line no-unused-vars
	const currentPageName = computed(() => store.getters.getCurrentPage);

	const togglePanel = () => {
		retracted.value = !retracted.value;
	}
	const currentVisiblePanel = ref('info');
	const showPanel = target => {
		currentVisiblePanel.value = target;
	}
	const clearConsole = () => {
		console.clear();
	};
	const trigger = (str) => {
		emit('trigger', str); // to inform the form
	};


	

	// eslint-disable-next-line no-unused-vars
	defineExpose({
		fc, offersStatusUnworkable, togglePanel, currentVisiblePanel, showPanel, clearConsole, shortDate, emit, props, trigger
	});
</script>

<!-- ================================================================================== -->

<template>
	<div id="cheatPanelv3">
		<button @click="togglePanel" id="toggler" :class="{retracted: retracted}"><span :class="{disabled: retracted}">◄</span> <span :class="{disabled: !retracted}">►</span></button>









		<!-- ================================================= -->
		<div class="panel" :class="{retracted: retracted}">

			<div class="devheader">
				<p class="actiontitle">«&nbsp;{{ lead.consumeractionname }}&nbsp;»</p>

				<div class="menu">
					<button @click="showPanel('info')" :class="{'active': currentVisiblePanel === 'info'}">Info</button>
					<button @click="showPanel('navigation')" :class="{'active': currentVisiblePanel === 'navigation'}">Navigation</button>
					<button @click="showPanel('functions')" :class="{'active': currentVisiblePanel === 'functions'}">Functions</button>
				</div>
			</div>

			



			<!-- ================================================= -->
			<div class="contentpanel" v-show="currentVisiblePanel === 'info'">

				
				<div class="identifiants">
					<div>ID: {{ lead.id }}</div>
					<div>RefHD: {{ lead.referencehd }}</div>
				</div>

				<p>
					Lead status: <span class="status" :class="{red: offersStatusUnworkable, green: !offersStatusUnworkable}">{{ lead.offerstatus }}: {{ lead.operationstatusreference.descriptionen }}</span> <span v-if="offersStatusUnworkable">⚠️</span>
				</p>

				<p>
					Is registration required?	<b>{{ (lead.registration == 1) ? 'yes' : 'no' }}</b><br>
					Is upload mandatory? <b>{{ lead.participationmandatoryuploadimage ? 'yes' : 'no' }}</b><br>
					Is there Metadatas? <b>{{ lead.leadmanagementmetadata.length > 1 ? 'yes, check console' : 'no' }}</b>
				</p>

				<p class="link_acceptance">
					<a :href="lead.participationurl" target="_blank">Test participation link</a>
				</p>


				<div class="dates">
					<div class="dates_section">
						<b>Registration</b> <dev-live :startDate="lead.registrationbegindate" :endDate="lead.registrationenddate" /><br>

						<div class="datum">
							{{ shortDate(lead.registrationbegindate) }} → {{ shortDate(lead.registrationenddate) }}
						</div>

						<span v-if="lead.maxregistrationcounter != 0">Max Registration: {{ lead.maxregistrationcounter }}<br></span>
						Registrations qtt: <b>{{ lead.inscriptions_total }}</b><br>
						<span v-if="lead.inscriptions_left < 999999999">Left: {{ lead.inscriptions_left }}<br></span>
					</div>

					<div class="dates_section">
						<b>Participation</b> <dev-live :startDate="lead.participationbegindate" :endDate="lead.participationextensiondate" />

						<div class="datum">
							{{ shortDate(lead.participationbegindate) }} → {{ shortDate(lead.participationextensiondate) }}
						</div>

						End reparticipation: {{ shortDate(lead.treatmentenddaterepart) }}<br>
						<span v-if="lead.maxparticipationcounter != 0">Max Participation: {{ lead.maxparticipationcounter }}<br></span>
						Participations qtt: <b>{{ lead.participations_total }}</b><br>
						<span v-if="lead.participations_left < 999999999">Left: {{ lead.participations_left }}<br></span>
					</div>

					<div class="dates_section">
						<b>Purchase</b> <dev-live :startDate="lead.purchasebegindate" :endDate="lead.purchaseenddate" /><br>
						<div class="datum">
							{{ shortDate(lead.purchasebegindate) }} → {{ shortDate(lead.purchaseenddate) }}
						</div>
					</div>								
				</div>





				<div class="countrylang">
					<div class="countrytitle">
						Country and lang
					</div>
					<div class="countrylanggrid">

						<div class="country">
							id Country - id Lang
							<ul>
								<li v-for="(value, index) in lead.leadfrontcountrylanguage" :key="`lfcl2-${index}`">
									{{value.frontcountrylanguagereference.idcountrycode}}-{{ ['Country0?', 'BE', 'FR', 'NL', 'LU', 'Country5?', 'Country6?', 'CH', 'Country8?'][value.frontcountrylanguagereference.idcountrycode] }}: {{value.frontcountrylanguagereference.idlanguagecode}}-{{ ['EN', 'FR', 'NL', 'C3?', 'DE', 'C5?', 'C6?'][value.frontcountrylanguagereference.idlanguagecode] }}
								</li>
							</ul>
						</div>

						<div class="lang">
							Langs (id - lang): 
							<ul>
								<li v-for="(value, index) in lead.leadfrontcountrylanguage" :key="`lfcl1-${index}`">
									{{ value.idfrontcountrylanguage }} - {{['EN', 'FR', 'NL (be)', 'NL (nl)', 'FR (lu)', 'CH (de)', 'CH (fr)', '???', '?', '??', '????'][value.idfrontcountrylanguage]}}
								</li>
							</ul>
						</div>



					</div>
				</div>

				<div v-if="lead.registration == 1" class="registrationcode">
					Codes to type for registration (whatsapp):<br>
					<ul>
						<li v-for="(code, key) in lead.registrationkeycode" :key="key">{{key}}: {{code}}</li>
					</ul>
				</div>

			</div>

			<!-- ================================================= -->
			<div class="contentpanel" v-show="currentVisiblePanel === 'navigation'">
				<fieldset>
					<legend>Form's pages</legend>
					<div class="buttongrid">
						<button v-for="page in fc.formPages" @click="$emit('goto', page);" :key="`n-${page}`" :class="{'active': currentPageName === page}">{{ page }}</button>
					</div>
				</fieldset>

				<fieldset>
					<legend>Common pages</legend>
					<div class="buttongrid">
						<button v-for="page in fc.functionnalPages" @click="$emit('goto', page);" :key="`n-${page}`" :class="{'active': currentPageName === page}">{{ page }}</button>
					</div>
				</fieldset>
			</div>

			<!-- ================================================= -->
			<div class="contentpanel" v-show="currentVisiblePanel === 'functions'">
				<fieldset>
					<!-- Trigger form's functions -->
					<legend>Console.log</legend>
					<div class="buttongrid">
						<button @click="clearConsole">Clear</button>
						<button @click="trigger('MandatoryFieldList')">Mandatory fields list</button>
						<button @click="trigger('MetaFieldsInfo')">Meta fields list</button>
						<button @click="trigger('CollectParticipationData')">Collect part. data</button>
						<button @click="trigger('CurrentFieldsValues')">Current fields values</button>
						<button @click="trigger('CurrentFieldsValidity')">Current fields validity</button>
						<button @click="trigger('SendParticipationNow')">Send participation</button>
					</div>
				</fieldset>
				<fieldset>
					<legend>Test form function</legend>
					<div class="buttongrid">
						<button @click="trigger('ToggleWatermark')">Toggle Watermark</button>
						<button @click="trigger('ShowSpinner5sec')">Show Spinner 5sec</button>
						<button @click="trigger('DisplayAnError')">Show error panel</button>
						<button @click="trigger('ToggleLang')">FR ⇄ NL</button>
					</div>
				</fieldset>
			</div>
		</div>
	</div>
</template>

<!-- ================================================================================== -->

<style lang="scss" scoped>

	#cheatPanelv3 {
		position: absolute;
		left: 0;
		top: 60px;
		font-family: 'Roboto', 'Open Sans', 'Segoe UI', sans-serif;
		z-index: 9999999999900;
		--admin-base-color: #7b4b94;

		--admin-nav-button-bg: #7b4b94;
		--admin-nav-button-bg-hover: #7d82b8;
		--admin-nav-button-bg-active: #fff;
		--admin-nav-button-color: #fff;
		--admin-nav-button-color-active: #000;

		--admin-content-button-bg: #d6dff9;
		--admin-content-button-bg-hover: #b7c5f0;
		--admin-content-button-bg-active: #fe9;
		--admin-content-button-color: #000;
		--admin-content-button-color-hover: #000;
		--admin-content-button-color-active: #000;
		
		button {
			font-family: inherit;
		}

		.panel {
			position: absolute;
			left: 0;
			border: 4px solid #fff;
			border-bottom-right-radius: 4px;
			border-top-right-radius: 4px;
			width: 350px;
			transition: left 0.3s ease-in-out;
			box-shadow: 0 0 16px #0003;
			max-height: 80lvh;
			overflow-x: hidden;
			overflow-y: auto;

			&.retracted {
				left: -350px;
			}
		}

		#toggler {
			padding: 0.75em 0.75em 0.75em 1em;
			margin-left: -6px;
			box-shadow: 0 0 6px #0003;
			cursor: pointer;
			transition: opacity 0.2s ease-in-out 0.1s;
			font-family: arial;

			display: flex;
			flex-direction: column;

			@media screen and (min-width: 600px){

				&.retracted {
					opacity: 0;
					transition: opacity 0.8s ease-in-out 1.2s;
				}

				&:hover {
					opacity: 1;
					transition: opacity 0.2s ease-in-out 0.1s;
				}

			}
		}

		#toggler span.disabled {
			color: #0003;
		}



		.devheader {
			// padding: 0.25em 1em 0.75em;
			color: #fff;
			background: var(--admin-base-color);
			border-top-right-radius: 2px;

			.menu {
				display: grid;
				grid-template-columns: 1fr 1fr 1fr;
				gap: 0.25em;

				button {
					border-radius: 0;
					padding: 0.5em 1em;
					border: none;
					cursor: pointer;
					background: var(--admin-nav-button-bg);
					color: var(--admin-nav-button-color);
					letter-spacing: 0.25px;
					text-transform: uppercase;
					font-weight: 600;

					&:hover {
						background: var(--admin-nav-button-bg-hover);
					}

					&.active {
						background: var(--admin-nav-button-bg-active);
						color: var(--admin-nav-button-color-active);
					}
				}
			}

		}






		.contentpanel {
			background: #fff;
			padding: 0.75em 1em 0.25em;
			border-bottom-right-radius: 2px;
		}

		.actiontitle {
			text-align: center;
			font-size: 1.2em;
			font-weight: bold;
			padding: 0.25em;
		}

		.datum {
			font-size: 0.9rem;
			padding: 0.5em 0;
		}

		.countrylang {}

		.countrytitle {
			font-weight: bold;
			text-align: center;
			padding: 0.5em 0;
		}

		.countrylanggrid {
			display: grid;
			grid-template-columns: 1fr 1fr;
		}


		fieldset {
			margin: 1.0em 0;
			border: none;
			border-top: 1px solid #000;
			width: 100%;
			padding: 0.5em 0;
		}

		.buttongrid {
			display: grid; 
			grid-template-columns: 1fr 1fr;
			gap: 0.25em;

			button {
				padding: 0.5em 0.5em;
				border-radius: 4px;
				border: none;
				color: var(--admin-content-button-color);

				background: var(--admin-content-button-bg);
				cursor: pointer;

				&:hover {
					background: var(--admin-content-button-bg-hover);
					color: var(--admin-content-button-color-hover);
				}
				&.active {
					background: var(--admin-content-button-bg-active);
					color: var(--admin-content-button-color-active);
				}
			}
		}

		span.red {
			color: #f00;
			font-weight: bold;
		}
		span.green {
			color: #0c0;
			font-weight: bold;
		}

		.identifiants {

			display: flex;
			flex-direction: row;
			justify-content: space-evenly;
			align-items: flex-start;
			font-weight: bold;
			font-size: 1.1em;
			padding: 0.5em 0;
		}

		.dates {
			border-radius: 0.5em;
			padding: 0.5em 0;
			margin: 0.5em auto;
			width: 100%;

			.dates_section {
				padding: 0.5em;
				background: #0001;
				margin-bottom: 1em;
				border-radius: 0.5em;

			}
		}
		.link_acceptance {
			text-align: center;
			padding: 0.5em 0;
		}

		ul {
			padding: 0.5em;
		}



	}
</style>
